import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { RotateCcwIcon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
import { proofPoints } from '../../data/teaser';
type ProofScreenProps = {
  onReplay: () => void;
};
const EASE = [0.23, 1, 0.32, 1] as const;
export function ProofScreen({
  onReplay
}: ProofScreenProps) {
  const [clicked, setClicked] = useState(false);
  return <div className="flex h-full flex-col" data-id="element-194" data-mp="29c84r2tqzsrj">
      <h2 className="text-[32px] font-semibold leading-[1.04] tracking-[-0.035em] text-ink" data-id="element-195" data-mp="2e9gmx3ewbwss">
        Individualization with evidence behind it.
      </h2>

      <ul className="mt-7 border-b border-ink/10" data-id="element-196" data-mp="2i9s9wmuqe97f">
        {proofPoints.map(p => <li key={p.title} className="border-t border-ink/10 py-4" data-id="element-197" data-mp="2nb7vcg0tmhqc">
            <p className="text-[16px] font-semibold leading-snug tracking-[-0.01em] text-ink" data-id="element-198" data-mp="3tr0eb85dnpbl">{p.title}</p>
            <p className="mt-1.5 inline-block rounded border border-dashed border-accent/40 bg-accent/[0.04] px-2 py-0.5 font-mono text-[10px] tracking-[0.06em] text-accent" data-id="element-199" data-mp="2jecll27xwxd">
              {p.placeholder}
            </p>
          </li>)}
      </ul>

      <p className="mt-6 text-[17px] font-medium leading-snug tracking-[-0.01em] text-ink" data-id="element-200" data-mp="2u0fop2v8zt7b">
        Different patients may need a more individualized starting approach.
      </p>

      <div className="mt-auto pt-6" data-id="element-201" data-mp="2k3uiie7hsc1w">
        <PrimaryButton onClick={() => setClicked(true)} data-id="element-202" data-mp="2g28y87smovho">SEE THE EVIDENCE</PrimaryButton>
        <div className="mt-2 flex h-5 items-center justify-center" data-id="element-203" data-mp="2bbsj8j95t1t7">
          <AnimatePresence initial={false} data-id="element-204" data-mp="2bahf2ibsxs1k">
            {clicked && <motion.p key="note" initial={{
            opacity: 0,
            y: 4
          }} animate={{
            opacity: 1,
            y: 0
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.18,
            ease: EASE
          }} className="text-[12px] text-graphite" data-id="element-205" data-mp="26dr05ybqh2hq">
                Opens the approved evidence page in the live Snak.
              </motion.p>}
          </AnimatePresence>
        </div>
        <PrimaryButton variant="outline" onClick={onReplay} className="mt-2" data-id="element-206" data-mp="1mqw88e3e0ys7">
          <span className="inline-flex items-center justify-center gap-2" data-id="element-207" data-mp="1mot8318itp9r">
            <RotateCcwIcon size={15} strokeWidth={2} aria-hidden="true" data-id="element-208" data-mp="18spglfp17v0z" />
            REPLAY
          </span>
        </PrimaryButton>
      </div>
    </div>;
}